<template>
  <div>
    <van-nav-bar title="尺码选择" left-text="" left-arrow @click-left="onClickLeft()" />
    <div class="tips">
      *说明：抽奖奖品为天力文化衫请选择尺码，选择尺码后请耐心等待配送！（请谨慎选择，选择成功后无法更改）
    </div>
    <div style="margin-left:20px;">
      <van-radio-group v-model="size" @change="selectSize">
        <van-radio name="M" style="padding-top:5px;">M</van-radio>
        <van-radio name="L" style="padding-top:5px;">L</van-radio>
        <van-radio name="XL" style="padding-top:5px;">XL</van-radio>
        <van-radio name="2XL" style="padding-top:5px;">2XL</van-radio>
        <van-radio name="3XL" style="padding-top:5px;">3XL</van-radio>
        <!-- <van-radio name="4XL" style="padding-top:5px;">4XL</van-radio> -->
      </van-radio-group>
    </div>
    <div style="text-align:center;">
      <van-button round type="info" size="normal" style="width:80%;" @click="SaveSize()">提交</van-button>
    </div>
    
  </div>
</template>

<script>
import { Button, NavBar, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      fileUrl: this.$file.url,
      size: "",
      drawId: 0
    };
  },
  props: {},
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    // 选择尺码 
    SaveSize() {
      var that = this;
      if(that.size==""){
        return that.$toast.fail("请先选择尺码");
      }
      that.$http.get("SDWorker/UpdateSize", {
          params: {
            id: that.drawId,
            size: that.size
          },
        }).then((res) => {
          if (res.data == "success") {
            this.$toast("提交成功~");
            this.$router.push({
              name: "LuckDrawRecord2024",
              params: { },
            });
          } else {
            that.$toast(res.data);
          }
      });
    },
    selectSize(s) {
      this.size=s;
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  mounted() {
  },
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [NavBar.name]:NavBar,
  },
  created() {
    this.drawId = this.$route.params.drawId;
  },
};

</script>

<style scoped>
.tips {
  font-size: 15px;
  color: red;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 5px;
}
</style>